/** Design tokens matching the Vertex Keycloakify theme */

export const COLORS = {
  dark: {
    bg: '#1a1a1e',
    card: '#292929',
    cardAlt: '#1f1f23',
    text: '#FFFFFF',
    textSecondary: '#AAAAAA',
    label: '#D1D1D1',
    border: '#3a3a3a',
  },
  light: {
    bg: '#e0e0e0',
    card: '#EEEEEE',
    cardAlt: '#f5f5f5',
    text: '#000000',
    textSecondary: '#555555',
    label: '#424242',
    border: '#d0d0d0',
  },
  accent: {
    blue: '#01A9ED',
    blueDark: '#0165C6',
    blueDeep: '#00407D',
    gold: '#F4C43F',
    cyan: '#00C9FF',
    navy: '#0035AA',
  },
} as const;

/** Color palette for either dark or light theme */
export type ColorTheme = typeof COLORS.dark | typeof COLORS.light;

export const GRADIENTS = {
  buttonLight: 'linear-gradient(90deg, #01A9ED, #0165C6)',
  buttonDark: 'linear-gradient(90deg, #0266C6, #00407D)',
  lightbar: 'linear-gradient(90deg, #F4C43F, #00C9FF, #0035AA)',
} as const;

export const SHADOWS = {
  neumorphicLight: '0 4px 16px rgba(0, 0, 0, 0.08)',
  neumorphicDark: '0 4px 16px rgba(0, 0, 0, 0.3)',
  cardLight: '0 2px 12px rgba(0, 0, 0, 0.06)',
  cardDark: '0 2px 12px rgba(0, 0, 0, 0.25)',
} as const;

export const FONTS = {
  heading: "'Questrial', sans-serif",
  body: "'Lato', sans-serif",
  mono: "ui-monospace, 'SF Mono', Menlo, Consolas, 'Liberation Mono', monospace",
} as const;

export const LAYOUT = {
  sidebarWidth: 64,
  topNavHeight: 56,
  lightbarHeight: 4,
  bottomBarHeight: 48,
  mobileHeaderHeight: 52,
  /** Phone / large-phone breakpoint used by the mobile shell. */
  mobileBreakpoint: 720,
} as const;

export const STATUS_COLORS = {
  online: '#4ADE80',
  offline: '#EF4444',
  maintenance: '#FBBF24',
  loading: '#6B7280',
} as const;
